import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const LifebuoyLine: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016C14.6666 11.682 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.682 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335ZM7.99992 11.3335C7.56992 11.3335 7.15898 11.2521 6.78158 11.1038L5.29061 12.595C6.08463 13.0642 7.01085 13.3335 7.99992 13.3335C8.98898 13.3335 9.91518 13.0642 10.7093 12.595L9.21825 11.1038C8.84085 11.2521 8.42992 11.3335 7.99992 11.3335ZM2.66659 8.00016C2.66659 8.98923 2.93582 9.91543 3.40502 10.7095L4.89626 9.2185C4.748 8.84109 4.66658 8.43016 4.66658 8.00016C4.66658 7.57016 4.748 7.15923 4.89626 6.78183L3.40502 5.29086C2.93582 6.08488 2.66659 7.0111 2.66659 8.00016ZM12.5948 5.29086L11.1036 6.78183C11.2519 7.15923 11.3333 7.57016 11.3333 8.00016C11.3333 8.43016 11.2519 8.84109 11.1036 9.2185L12.5948 10.7095C13.064 9.91543 13.3333 8.98923 13.3333 8.00016C13.3333 7.0111 13.064 6.08488 12.5948 5.29086ZM7.99992 6.00016C6.89532 6.00016 5.99992 6.89556 5.99992 8.00016C5.99992 9.10476 6.89532 10.0002 7.99992 10.0002C9.10452 10.0002 9.99992 9.10476 9.99992 8.00016C9.99992 6.89556 9.10452 6.00016 7.99992 6.00016ZM7.99992 2.66683C7.01085 2.66683 6.08463 2.93607 5.29061 3.40526L6.78158 4.8965C7.15898 4.74825 7.56992 4.66683 7.99992 4.66683C8.42992 4.66683 8.84085 4.74825 9.21825 4.8965L10.7093 3.40526C9.91518 2.93607 8.98898 2.66683 7.99992 2.66683Z"
        fill={color}
      />
    </svg>
  );
};

export default LifebuoyLine;
